<h2 mat-dialog-title>{{ 'APPOINTMENT.BULK_EDIT_TITLE' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <div *ngIf="isLoading" class="flex justify-center items-center py-4">
    <mat-spinner diameter="30"></mat-spinner>
    <span class="ml-3 text-gray-600">{{ 'DIALOG.LOADING_DATA' | translate }}</span>
  </div>

  <div *ngIf="!isLoading" class="dialog-content space-y-4">
    <p class="text-sm text-gray-600">
      {{ 'APPOINTMENT.BULK_EDIT_HINT' | translate:{ count: data.count } }}
    </p>

    <!-- Techniker -->
    <div class="form-group">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="bulk_techniker_id">{{ 'HEADER_INFO.TECHNICIAN' | translate }}</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="bulk_techniker_id"
        [(ngModel)]="selectedTechnikerId">
        <option value="">{{ 'APPOINTMENT.BULK_UNCHANGED' | translate }}</option>
        <option *ngFor="let techniker of technikerOptions" [value]="techniker.id">
          {{ techniker.display_name }} ({{ techniker.nummer }}) - {{ techniker.funktion }}
        </option>
      </select>
    </div>

    <!-- Status -->
    <div class="form-group">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="bulk_status_id">{{ 'COMMON.STATUS' | translate }}</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="bulk_status_id"
        [(ngModel)]="selectedStatusId">
        <option value="">{{ 'APPOINTMENT.BULK_UNCHANGED' | translate }}</option>
        <option *ngFor="let status of statusOptions" [value]="status.id">
          {{ status.label }}
        </option>
      </select>
    </div>

    <!-- Durchführungsdatum -->
    <div class="form-group" *ngIf="canEditDatum">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="bulk_pruefdatum">{{ 'HEADER_INFO.PRUEFDATUM' | translate }}</label>
      <input
        type="date"
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="bulk_pruefdatum"
        [(ngModel)]="datumDurchfuerung" />
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions flex justify-between">
  <button mat-button color="warn" (click)="onDelete()">
    <mat-icon class="mr-1">delete</mat-icon>
    {{ 'COMMON.DELETE' | translate }}
  </button>

  <div>
    <button mat-button (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button mat-button color="primary" [disabled]="!hasChanges()" (click)="onSave()">
      {{ 'COMMON.SAVE' | translate }}
    </button>
  </div>
</mat-dialog-actions>
